<template>
  <v-card class="pa-4 rounded-0" flat>
    <v-card-title
      class="section-title text-center pa-2"
      style="color: inherit !important"
    >
      {{ title }}
    </v-card-title>
    <v-card-subtitle class="ma-0 pa-2" style="color: inherit !important">
      {{ description }}
    </v-card-subtitle>

    <v-row no-gutters>
      <v-col v-for="(item, i) in value" :key="i" class="pa-2" cols="12">
        <v-card
          :href="!!item.link ? fixLink(item.link) : ''"
          class="rounded-lg overflow-hidden"
          :style="{ background: item.color }"
          outlined
          target="_blank"
        >
          <v-responsive :aspect-ratio="16 / 9">
            <template v-if="item.icon">
              <v-card-title class="justify-center flex-column">
                <v-icon size="85">{{ item.icon }}</v-icon>
              </v-card-title>

              <v-card-text class="text-center">
                {{ item.content }}
              </v-card-text>
            </template>

            <template v-else>
              <div
                :style="`background-image: url(${getBgImg(item)})`"
                class="b-service-background"
              >
                <span
                  class="text-center b-service-content"
                  v-html="item.content"
                  :style="`color: ${color} !important`"
                />

                <div class="b-content-slider" />
              </div>
            </template>
          </v-responsive>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "bServiceView",

  props: {
    title: String,
    description: String,
    type: {
      type: String,
      default: "gradient", // [icon, image, gradient]
    },
    value: Array,
    color: String,
  },

  watch: {
    value: {
      deep: true,

      handler(val) {
        this.$forceUpdate();
      },
    },
  },

  mounted() {},

  methods: {
    fixLink(link) {
      return link.startsWith("http") ? link : "https://" + link;
    },
    getBgImg(item) {
      return item.image ?? item.gallery[0]?.images[0]?.url;
    },
  },
};
</script>

<style lang="scss" scoped>
pre {
  font-family: Vazir, serif !important;
  white-space: break-spaces;
  overflow: hidden;
}

.section-title {
  position: relative;

  &:before {
    content: "";
    width: 150px;
    height: 1px;
    background: var(--v-primary-base);
    position: absolute;
    bottom: 0;
    right: 0;
  }
}

.b-service-background {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
  width: 100%;
  transition: all 0.3s ease-out;
  background-size: cover !important;
  background-position: center !important;

  &:before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    height: 50%;
    width: 100%;
    border-radius: 8px 8px 0 0;
    background: rgba(0, 0, 0, 0.5);
    transition: inherit;
    z-index: 0;
  }

  &:hover {
    &:before {
      height: 100%;
      border-radius: 0;
    }

    div.b-service-content {
      transform: translateY(-20%);
    }

    .b-content-slider {
      visibility: visible;
      width: calc(100% - 32px);
    }
  }

  & > * {
    position: relative;
    z-index: 1;
    color: white;
    transition: inherit;
  }

  .b-content-slider {
    visibility: hidden;
    background: #fff;
    height: 2px;
    border-radius: 10px;
    width: 0;
    margin: 0 auto 16px 16px;
  }
}
</style>
